import Vue from 'vue'
import App from './App.vue'
import './assets/tailwind.css';

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faDiscord,
  faTwitch,
  faYoutube,
  faInstagram,
  faTiktok,
  faKickstarterK,
  faXTwitter,
} from '@fortawesome/free-brands-svg-icons'
import {
  faCircleDollarToSlot,
  faGift,
  faCopy,
  faCheck,
  faEnvelope,
  faPlay,
  faArrowUpRightFromSquare,
  faKeyboard,
  faHeadset,
  faTrophy,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faDiscord,
  faTwitch,
  faYoutube,
  faInstagram,
  faTiktok,
  faKickstarterK,
  faXTwitter,
  faGift,
  faCircleDollarToSlot,
  faCopy,
  faCheck,
  faEnvelope,
  faPlay,
  faArrowUpRightFromSquare,
  faKeyboard,
  faHeadset,
  faTrophy,
  faXmark
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

new Vue({
  render: h => h(App),
}).$mount('#app')
